export default "__VITE_ASSET__d6VugzZv__"